import React from "react";
import { w2pt, izoom } from "../../utils/coords";
import { Geo } from "../../utils/geo";
import { WORLD_SNAP } from "../../constants";
import { formatDistanceAuto, UNIT_PRESETS } from "../../utils/units";

export default function DrawPreview({ startMm, cursorMm, zoom, unitPreset = UNIT_PRESETS.DEFAULT, showAngle = false }) {
  if (!startMm || !cursorMm) return null;
  const s  = izoom(zoom);
  const pS = w2pt(startMm), pE = w2pt(cursorMm);
  const len = Geo.d(startMm, cursorMm);
  const dx = cursorMm.x - startMm.x;
  const dy = cursorMm.y - startMm.y;
  const angleDeg = Math.atan2(dy, dx) * 180 / Math.PI;
  const displayAngle = angleDeg < 0 ? angleDeg + 360 : angleDeg;

  return (
    <g style={{ pointerEvents: "none" }}>
      <line x1={pS.x} y1={pS.y} x2={pE.x} y2={pE.y}
        stroke="#3b82f6" strokeWidth={s * 0.8} strokeDasharray={`${s * 6},${s * 3}`} opacity={0.85} />
      <circle cx={pS.x} cy={pS.y} r={s * 3} fill="#3b82f6" stroke="#030508" strokeWidth={s} />
      <circle cx={pE.x} cy={pE.y} r={s * 2.5} fill="none" stroke="#3b82f6" strokeWidth={s} />
      {len > WORLD_SNAP * 0.3 && (
        <>
          <text x={(pS.x + pE.x) / 2 + s * 5} y={(pS.y + pE.y) / 2 - s * 9}
            fontSize={s * 8} fill="#3b82f6" fontWeight={700} fontFamily="'JetBrains Mono',monospace">
            {formatDistanceAuto(len, unitPreset)}
          </text>
          {showAngle && (
            <text x={(pS.x + pE.x) / 2 + s * 5} y={(pS.y + pE.y) / 2 + s * 4}
              fontSize={s * 7} fill="#a78bfa" fontWeight={600} fontFamily="'JetBrains Mono',monospace">
              {displayAngle.toFixed(1)}°
            </text>
          )}
        </>
      )}
    </g>
  );
}
